import type { SendMessageInput, SendMessageResult } from '../schemas/chats.schema'
import type { OrderChatHistory } from '@/lib/ymarket-chat'
import { apiFetch, readApiJson } from '@/lib/api-fetch'

export async function sendChatMessage(input: SendMessageInput): Promise<SendMessageResult> {
  const res = await apiFetch('/api/ymarket/chats/send', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
  return await readApiJson<SendMessageResult>(res)
}

export async function fetchOrderChatHistory(orderId: number, chatId?: number): Promise<OrderChatHistory> {
  const query = new URLSearchParams({ orderId: String(orderId) })
  if (chatId) query.set('chatId', String(chatId))
  const res = await apiFetch(`/api/ymarket/chats/history?${query}`, {
    // The provider indexes a successful send asynchronously. Never let a browser
    // cache make a manual refresh or bounded verification poll look unchanged.
    cache: 'no-store',
    headers: { 'Cache-Control': 'no-cache' },
  })
  return await readApiJson<OrderChatHistory>(res)
}
